var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshotBlockerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 20.4002V18.6002H17.4V15.6002H19.2V20.4002H14.4ZM9.6 13.2002V8.4002H14.4V10.2002H11.4V13.2002H9.6ZM8.4 27.6002C7.74 27.6002 7.175 27.3652 6.705 26.8952C6.235 26.4252 6 25.8602 6 25.2002V3.6002C6 2.9402 6.235 2.3752 6.705 1.9052C7.175 1.4352 7.74 1.2002 8.4 1.2002H20.4C21.06 1.2002 21.625 1.4352 22.095 1.9052C22.565 2.3752 22.8 2.9402 22.8 3.6002V25.2002C22.8 25.8602 22.565 26.4252 22.095 26.8952C21.625 27.3652 21.06 27.6002 20.4 27.6002H8.4ZM8.4 21.6002H20.4V7.2002H8.4V21.6002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotBlockerIcon);
export default __webpack_public_path__ + "static/media/ScreenshotBlockerIcon.08051ce505c2f2180f2faf3dc924d377.svg";
export { ForwardRef as ReactComponent };